import { FaqItem } from '@/app/components/Faq/Item'
import { UI } from '@/app/components/UI/UI'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const Faq: FunctionalComponent<{
  items: {
    question: string
    answer: string
    link?: {
      href: string
      text: string
    }
  }[]
}> = props => {
  return (
    <div class={styles.root}>
      <UI.Panel class={styles.panel}>
        {props.items.map(item => (
          <FaqItem
            answer={item.answer}
            link={item.link}
            question={item.question}
          />
        ))}
      </UI.Panel>
    </div>
  )
}
